import styled from "styled-components";
import { device } from "../styles/deviceSizes";
export const AccommodationHighlightsWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: white;
`;
export const VillaDescriptionWrapper = styled.div`
  position: absolute;
  top: 30%;
  p {
    color: white;
  }
  text-align: center;
  width: 100%;
  padding: 0px 30px;
  z-index: 2;
`;

export const RecommendedContentWrapper = styled.div`
  /* width: 100%; */
  height: 100%;
  padding: 0 6rem 5rem 6rem;
  @media ${device.onlyMobile} {
    padding: unset;
  }
  background: white;
`;

export const EnquireButtonWrapper = styled.div`
  width: 100%;
  align-self: center;
  background: none;
  display: flex;
  justify-content: center;
  @media ${device.onlyMobileSm} {
    margin-bottom: 5rem;
  }

  button {
    width: 23rem;
  }
`;
